import React, { useState, useEffect } from "react";
import Cookie from "js-cookie";

// https://stackoverflow.com/a/1099670
function getQueryParams(qs) {
  qs = qs.split("+").join(" ");
  var params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while ((tokens = re.exec(qs))) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }
  return params;
}
const query = getQueryParams(document.location.search);
const tabQuery = query.tab ? query.tab : Cookie.get("activeTab");

export default function Tabs({ tabs }) {
  const [activeTab, setActiveTab] = useState(
    tabQuery ? tabs.findIndex((tab) => tab.id == tabQuery) : 0
  );

  const handleKeyDown = (event) => {
    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
      setActiveTab((activeTab + 1) % tabs.length);
    } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
      setActiveTab((activeTab + tabs.length - 1) % tabs.length);
    }
  };

  useEffect(() => {
    Cookie.set("activeTab", tabs[activeTab].id);
  }, [activeTab]);

  return (
    <div className="tabs">
      <div className="tablist-wrapper">
        <div className="content content--wide">
          <div className="tablist" role="tablist">
            {tabs.map((tab, index) => (
              <button
                className={`tablist-button icon-${tab.title === "List View" ? "list" : "map"}`}
                key={index}
                id={`tab-${index}`}
                role="tab"
                aria-selected={activeTab === index}
                aria-controls={`panel-${index}`}
                onKeyDown={handleKeyDown}
                onClick={() => {
                  setActiveTab(index);
                }}
              >
                {tab.title}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="tabpanel" role="tabpanel">
        {tabs.map((tab, index) => (
          <div key={index} id={`panel-${index}`} hidden={activeTab !== index}>
            {activeTab === index && tab.content}
          </div>
        ))}
      </div>
    </div>
  );
}
